/** Municípios que abrem o diálogo de sincronização de pessoa (busca por código). */
export const MUNICIPIOS_DIALOG_SINCRONIZA_PESSOA = [
  "vitoriadaconquista",
  "riobranco",
] as const;

export function isMunicipio(
  municipio: string | undefined | null,
  lista: readonly string[]
): boolean {
  const key = municipio?.toLowerCase();
  return !!key && (lista as readonly string[]).includes(key);
}

export function usaDialogSincronizaPessoa(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_DIALOG_SINCRONIZA_PESSOA);
}

/** Municípios que não exibem os botões de vincular/desvincular pessoa manualmente. */
export const MUNICIPIOS_OCULTA_VINCULO_MANUAL_PESSOA = [
  "riobranco",
] as const;

export function ocultaBotoesVinculoManualPessoa(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_OCULTA_VINCULO_MANUAL_PESSOA);
}

/** Fallback quando `edificacoesHierarquicasPorTipoVinculo` ainda não está no tenantConfig. */
export const MUNICIPIOS_EDIFICACOES_HIERARQUICAS = ["riobranco"] as const;

/** Municípios que suportam a funcionalidade de desmembrar imóveis (DialogSplitImobiliario). */
export const MUNICIPIOS_USA_SPLIT_IMOBILIARIO = ["maracanau", "vitoriadaconquista"] as const;

export function usaSplitImobiliario(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_SPLIT_IMOBILIARIO);
}

/** Municípios que suportam a funcionalidade de juntar imóveis (DialogJoin). */
export const MUNICIPIOS_USA_JOIN_IMOBILIARIO = ["maracanau", "vitoriadaconquista", "riobranco"] as const;

export function usaJoinImobiliario(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_JOIN_IMOBILIARIO);
}

/** Municípios que usam a rota de situação do IPTU (`situacao-iptu`). */
export const MUNICIPIOS_USA_SITUACAO_IPTU = ["maracanau"] as const;

export function usaSituacaoIptu(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_SITUACAO_IPTU);
}

/** Municípios cujo desmembramento exige campos extras (telheiro/galpão). */
export const MUNICIPIOS_SPLIT_TELHEIRO_GALPAO = ["vitoriadaconquista"] as const;

export function usaTelheiroGalpaoNoSplit(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_SPLIT_TELHEIRO_GALPAO);
}

